module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || '6abzc6fb',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
